import { render } from "./LandingPage.vue?vue&type=template&id=1c0d9c08&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=1c0d9c08&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0d9c08"],['__file',"src/views/LandingPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c0d9c08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c0d9c08', __exports__)) {
    api.reload('1c0d9c08', __exports__)
  }
  
  module.hot.accept("./LandingPage.vue?vue&type=template&id=1c0d9c08&scoped=true", () => {
    api.rerender('1c0d9c08', render)
  })

}


export default __exports__